<template>
    <div class="row justify-content-center">
        <div class="col col-md-6 text-center">
            <small class="font-weight-bold">
                {{ step.overline }}
            </small>
            <h4>{{ step.title }}</h4>
            <simple-image
                v-if="imageStep"
                :url="imageStep"
                classesFather="my-4 mx-auto d-flex align-items-center justify-content-center"
                sizeWidth="192"
                sizeHeight="192"
            />
            <h1 v-else class="my-5 text-secondary">{{altImageStep}}</h1>
            <vue-markdown :source="step.description" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import VueMarkdown from "vue-markdown";
    import SimpleImage from '../../../atoms/SimpleImage';

    export default {
        name: "CompanyStep",
        components: { SimpleImage, VueMarkdown },
        props: {
            step: Object
        },
        computed: {
            ...mapGetters({
                companyInfo: 'user/getCompanyInfo'
            }),
            imageStep() {
                return this.companyInfo.logo;
            },
            altImageStep() {
                return this.companyInfo.name;
            }
        }
    }
</script>
